<template lang="pug">
  .div
    .columns.has-text-centered(v-show="!verForm")
      .column.is-8
        h1.is-size-4
          strong  Autotanques
          | &nbsp
          a.button.is-black.is-rounded.is-small(@click="verNuevo")
            i.fas.fa-plus
            | &nbspNuevo
      .column.is-4
        .field
          .control
            input.input.is-black(
              type='text', 
              placeholder='🔎 Buscar por PG | Grupo | Comercializadora',
              v-model="query",
            )
    .columns.has-tetx-centered
      .column.is-offset-2.is-8
        TBAutotanques(:pg="pg_show" v-show="!verForm")
    .columns
      .column.is-12
        FormAutotanques(v-show="verForm" @closeForm="checkFormAutotanques")
</template>

<script>
  import TBAutotanques from '../componentes/TbAutotanques.vue'
  import FormAutotanques from './FormAutotanques.vue'

  export default {
    name: 'ContainerAutotanques',
    components: { TBAutotanques, FormAutotanques},
    props: {
      pg: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        verForm: false,
        query: '',
        pg_show: []
      }
    },
    watch: {
      query() {
        console.log(this.query)
        const autFilter = this.pg.filter( ports => { 
          return `${ports.pg} ${ports.grupo} ${ports.comercializadora}`.toUpperCase().includes(this.query)
        }) 
        console.log(autFilter)
        this.pg_show = autFilter
      },
      pg() {
        this.pg_show = this.pg
      }
    },
    methods: {
      verNuevo() {
        this.verForm = true
      },
      checkFormAutotanques (result) {
        console.log(`chekFormAutotanques - result ${result}`)
        if (result === 'saved') {
          this.$emit('updTBAutotanques', true)
        } 
        this.verForm = false
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/ContainerAutotanques.vue